import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import {Link} from 'react-router-dom'
import MuiLink from '@mui/material/Link'
import React from 'react'
import {Grid, IconButton, Typography} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface AnonAddDeckDialog {
  deckId: number
  open: boolean
  handleCloseCancel: () => void
}

export default function AnonAddDeckDialog(props: AnonAddDeckDialog) {
  return (
    <Dialog
      fullWidth
      open={props.open}
      onClose={props.handleCloseCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant='h5'>Log in or Sign Up</Typography>
          <IconButton onClick={props.handleCloseCancel} >
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1'>
          You are not logged in.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Link to="/sign-up" style={{textDecoration: "none", color: "inherit"}}>
        <Button
          variant="contained"
          color="success"
          sx={{
            fontSize: '18px',
            fontWeight: 900,
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
          }}
          >Sign Up</Button>
        </Link>
        <Link to="/login" style={{textDecoration: "none", color: "inherit"}}>
        <Button
          variant="contained"
          color="success"
          sx={{
            fontSize: '18px',
            fontWeight: 900,
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
          }}
          >Login</Button>
        </Link>
      </DialogActions>
    </Dialog>
  )
}

